import React from "react";
import { Container, Text, Space } from "@mantine/core";
import { Modal } from "../Modal/Modal";
import { Title } from "../Title/Title";

type ModalOrderConfirmedProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
};

export const ModalOrderConfirmed: React.FC<ModalOrderConfirmedProps> = ({
  ...props
}: ModalOrderConfirmedProps) => {
  return (
    <Modal
      dataTestId="modal-order-confirmed"
      isOpen={props.isOpen}
      variant={{
        type: "VALIDATION",
        buttonText: "Voir ma commande",
        onClose: props.onClose,
      }}
      withCloseButton={false}
      buttonPosition="center"
      size="xl"
      padding="xl"
    >
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Title
          size={2}
          variant="primary"
          title="Commande passée avec succès !"
        />
        <Space h="lg" />
        <Title size={2} variant="success" title={props.title} />
        <Space h="md" />
        <Text
          style={{
            textAlign: "center",
          }}
        >
          Vous pouvez suivre votre commande depuis votre dashboard, ou en
          cliquant ci-dessous
        </Text>
      </Container>
    </Modal>
  );
};
